
import axios from "axios";
import GLOBAL from "../../Global.js";

export default class VehiculoService {

    getFlotasConVehiculos(person, tercero) {
        var url1 = GLOBAL.API_GET_FLOTA + '?empresa_id=' + tercero._id;
        console.log(url1)
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getVehiculoId(person, uniqueid) {

        var url1 = GLOBAL.API_GET_VEHICULO_ID + '?uniqueid=' + uniqueid;
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getListaIbutton(person) {

        var url1 = GLOBAL.API_GET_IBUTTON_ID;
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    crearFlota(person, request) {
        var url1 = GLOBAL.API_GET_FLOTA_CREAR;
        return axios
            .post(url1.trim(), request, {
                timeout: 60000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d)
            .catch(function (error) {
                if (error.response) {
                    // Request made and server responded
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    return error
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
            });
    }

    //Desde FLOTAS
    crearVehiculoAgregandoAflota(person, request) {
        console.log(request)
        var url1 = GLOBAL.API_POST_VEHICULO_CREAR;
        return axios
            .post(url1.trim(), request, {
                timeout: 60000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(response => response)
            .catch(error => error.response);
    }


    crearVehiculo(person, request) {
        var url1 = GLOBAL.API_VEHICULOS_CREAR;
        return axios
            .post(url1.trim(), request, {
                timeout: 60000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(response => response)
            .catch(error => error.response);
    }

    removerVehiculoDeFlota(person, request) {
        var url1 = GLOBAL.API_POST_VEHICULO_REMOVER;
        return axios
            .put(url1.trim(), request, {
                timeout: 60000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(response => response)
            .catch(error => error.response);
    }

    actualizaFlota(person, request) {
        var url1 = GLOBAL.API_GET_FLOTA_ACTUALIZAR;
        return axios
            .post(url1.trim(), request, {
                timeout: 60000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d)
            .catch(function (error) {
                if (error.response) {
                    // Request made and server responded
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    return error.response
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
            });

    }

    actualizaFlotaFull(person, request) {
        var url1 = GLOBAL.API_GET_FLOTA_ACTUALIZAR_FULL;
        return axios
            .put(url1.trim(), request, {
                timeout: 60000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d)
            .catch((error) => console.log(error));
    }


    getListaVehiculos(person) {
        var url1 = GLOBAL.API_VEHICULOS_LISTA;
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getTerceroByRFC(person, request) {
        var url1 = GLOBAL.API_CLIENTES_FIND + "/" + person.empresas + "/" + request;
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(response => response)
            .catch(error => error.response);
    }

    getVehiculosPorPlaca(person, request) {
        var url1 = GLOBAL.API_VEHICULOS_FIND + "/" + request;
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(response => response)
            .catch(error => error.response);
    }


    actualizarVehiculo(person, request) {
        var url1 = GLOBAL.API_VEHICULOS_ACTUALIZA;
        return axios
            .put(url1.trim(), request, {
                timeout: 60000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(response => response)
            .catch(error => error.response);
    }

    crearConversion(person, request) {
        var url1 = GLOBAL.API_CONVERSION_CREAR;
        return axios
            .post(url1.trim(), request, {
                timeout: 60000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(response => response)
            .catch(error => error.response);
    }

    getListaAcuerdos(person) {
        var url1 = GLOBAL.API_ACUERDOS_LISTA;
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    actualizarAcuerdo(person, acuerdo) {
        var url1 = GLOBAL.API_ACUERDOS_UPDATE;
        return axios
            .put(url1.trim(), acuerdo, {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(response => response)
            .catch(error => error.response);
    }

    crearAcuerdo(person, acuerdo) {
        var url1 = GLOBAL.API_ACUERDOS_CREATE;
        return axios
            .post(url1.trim(), acuerdo, {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(response => response)
            .catch(error => error.response);
    }

    getListaAlianzas(person) {
        var url1 = GLOBAL.API_ALIANZAS_LISTA;
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    actualizarAlianzas(person, acuerdo) {
        var url1 = GLOBAL.API_ALIANZAS_UPDATE;
        return axios
            .put(url1.trim(), acuerdo, {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(response => response)
            .catch(error => error.response);
    }


    getReporteRecaudos(person, fechainicio, fechafin) {
        var url1 = GLOBAL.API_REPORTE_RECAUDOS + "?fechainicio=" + fechainicio + ":00.000&fechafin=" + fechafin + ":59.999 ";
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getIdentificadoresPorVehiculo(person, request) {
        var url1 = GLOBAL.API_VEHICULOS_IDENTIFICADORES_FIND + "/" + request;
        return axios
            .get(url1.trim(), {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    vincularIdentificador(person, request) {
        var url1 = GLOBAL.API_VEHICULOS_IDENTIFICADORES_FIND;
        return axios
            .post(url1.trim(), request, {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    desvincularIdentificador(person, request) {
        var url1 = GLOBAL.API_VEHICULOS_IDENTIFICADORES_FIND;
        return axios
            .delete(url1, {
                data: request, // En lugar de enviar request como argumento, envíalo como parte de la configuración.
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access-Control-Allow-Origin': '*',
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                }
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

}